import { Vector3 } from 'three';

export class Face3D {
  public vertices: Vector3[];

  public constructor(vertices: Vector3[]) {
    this.vertices = vertices;
  }
}
